import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { AIDisclosureState } from '../../types';
import { AIDisclosureStep } from '../../enums';
import { AIDisclosureModel } from '../disclosure-model';

function createAIDisclosureState(): AIDisclosureState {
    return {
        taskId: '',
        input: '',
        currentStep: AIDisclosureStep.DEFAULT,
        stepDetail: {},
    };
}

@injectable()
export class AIDisclosureModelImpl extends AbstractModel<AIDisclosureState> implements AIDisclosureModel {
    protected _modelData: AIDisclosureState = createAIDisclosureState();

    public dispose() {
        this.update(() => {
            return createAIDisclosureState();
        });
    }
}
